import request from 'reqwest';
import when from 'when';
import PerkConstants from '../constants/PerkConstants';
import AuthService from '../services/AuthService';

class PerkService {
  create(data) {
    let perk;
    if (data.referral_bonus) {
      perk = {
          title: data.title,
          description: data.description,
          referral_bonus: data.referral_bonus,
          fine_print: data.fine_print,
          required_referrals: 0,
          expire_date: data.expire_date,
          receiver_perk_id: data.receiver_perk_id ,
          enabled: data.enabled,
          requires_qr_code: data.requires_qr_code,
      }
    } else {
      perk = {
          title: data.title,
          description: data.description,
          referral_bonus: data.referral_bonus,
          fine_print: data.fine_print,
          required_referrals: data.required_referrals,
          expire_date: data.expire_date,
          receiver_perk_id: data.receiver_perk_id ,
          enabled: data.enabled,
          requires_qr_code: data.requires_qr_code,
      }
    }
    return when(request({
      url: PerkConstants.PERK_URL,
      method: 'POST',
      crossOrigin: true,
      contentType: 'application/json',
      withCredentials: true,
      type: 'json',
      headers: {
        'Authorization': 'Token token=' + AuthService.getUser().jwt
      },
      data: JSON.stringify({
        perk
      })
    }));
  }

  update(data) {
    delete data.required_referrals;
    return when(request({
      url: PerkConstants.PERK_URL + data.id,
      method: 'PUT',
      crossOrigin: true,
      contentType: 'application/json',
      withCredentials: true,
      type: 'json',
      headers: {
        'Authorization': 'Token token=' + AuthService.getUser().jwt
      },
      data: JSON.stringify({
        perk: data
      })
    }));
  }

  delete(id) {
    return when(request({
      url: PerkConstants.PERK_URL + id,
      method: 'DELETE',
      crossOrigin: true,
      contentType: 'application/json',
      withCredentials: true,
      type: 'json',
      headers: {
        'Authorization': 'Token token=' + AuthService.getUser().jwt
      },
    }));
  }

  list(filter) {
    return when(request({
      url: PerkConstants.PERK_URL,
      method: 'GET',
      crossOrigin: true,
      headers: {
        'Authorization': 'Token token=' + AuthService.getUser().jwt
      },
      contentType: 'application/json',
      withCredentials: true,
      type: 'json',
      data: filter
    }));
  }
  getCount() {
    return when(request({
      url: PerkConstants.PERK_URL + 'count',
      method: 'GET',
      crossOrigin: true,
      headers: {
        'Authorization': 'Token token=' + AuthService.getUser().jwt
      },
      contentType: 'application/json',
      withCredentials: true,
      type: 'json'
    }));
  }

  get(id) {
    return when(request({
      url: PerkConstants.PERK_URL + id,
      method: 'GET',
      crossOrigin: true,
      contentType: 'application/json',
      withCredentials: true,
      type: 'json',
      headers: {
        'Authorization': 'Token token=' + AuthService.getUser().jwt
      }
    }));
  }


}

export default new PerkService()



/** WEBPACK FOOTER **
 ** ./src/services/PerkService.js
 **/